import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/app/App";
import { initSentry } from "@/shared/lib/sentry";
import "@/shared/lib/i18n";
import "./index.css";

// Initialise crash reporting before anything renders so early boot
// errors are captured. No-op in development / when no DSN is configured.
initSentry();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
